export default __webpack_public_path__ + "static/jaroslav-b51536b07d7f7e386ce4af1b1999570f.png";